var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCirclearrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "45F1AD87-ACDB-46D1-B472-CC07F2BD2022") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,6.3406821 L19,5 L21,5 L21,10 L16,10 L16,8 L17.7467357,8 C16.4534879,6.14457578 14.3274446,5 12.0002166,5 C8.13405317,5 4.9997,8.13379396 4.9997,11.9994834 C4.9997,15.8654098 8.13429021,19 12.0002166,19 C15.865906,19 18.9997,15.8656468 18.9997,11.9994834 L20.9997,11.9994834 C20.9997,16.9701365 16.9705554,21 12.0002166,21 C7.02972071,21 2.9997,16.9699793 2.9997,11.9994834 C2.9997,7.02914457 7.02956354,3 12.0002166,3 C14.7694236,3 17.3183784,4.26178966 19,6.3406821 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-D-Crop-picture",
    transform: "translate(-707.000000, -659.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(425.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_circlearrow",
    transform: "translate(279.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCirclearrow);
export default __webpack_public_path__ + "static/media/ico_circlearrow.2915e5c3e703383171a757e5ab370f58.svg";
export { ForwardRef as ReactComponent };